export default __webpack_public_path__ + "static/HDR-how-hometown-works-icon-2-81cbbc2a5ef3188cac0e823c55ea14da.png";